import React from 'react';
import {Box, useTheme} from '@mui/material';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';
import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import {PowerStationCommunicationState} from '../PerformanceAnalysisReducer';

const STATE_COLORS: Record<PowerStationCommunicationState, string> = {
    COMMUNICATING: '#1BB483',
    NO_COMMUNICATION: '#FF7800',
    SYNCHRONIZING: '#2D5DE7',
};

const STATE_LABELS: Record<PowerStationCommunicationState, string> = {
    COMMUNICATING: 'Comunicando',
    NO_COMMUNICATION: 'Sem comunicação',
    SYNCHRONIZING: 'Sincronizando',
};

const ICON_BY_STATE: Record<PowerStationCommunicationState, React.ReactElement> = {
    COMMUNICATING: <WifiOutlinedIcon sx={{fontSize: 20}} />,
    NO_COMMUNICATION: <WifiOffOutlinedIcon sx={{fontSize: 20}} />,
    SYNCHRONIZING: <SyncOutlinedIcon sx={{fontSize: 20}} />,
};

export interface PlantCommunicationIndicatorProps {
    state: PowerStationCommunicationState;
}

export function PlantCommunicationIndicator({state}: PlantCommunicationIndicatorProps) {
    const theme = useTheme();
    const backgroundColor = STATE_COLORS[state];
    const label = STATE_LABELS[state];
    const iconColor = state === 'COMMUNICATING' && theme.palette.mode === 'dark' ? '#062A1C' : '#FFFFFF';

    return (
        <Box
            role="img"
            aria-label={label}
            sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor,
                color: iconColor,
            }}
        >
            {ICON_BY_STATE[state]}
        </Box>
    );
}
